import { useMutation } from 'hooks/useMutation'

import { formatError } from 'utils/formatError'
import { Log } from 'utils/logger'
import { fetchGroupById, fetchGroupByUserId, postGroup } from 'utils/queries'
import { Toast } from 'utils/toast'

import { Program } from 'types/program'

import { useQuery } from './useQuery'

export const useGroup = ({
  userId,
  groupId,
}: {
  userId?: string
  groupId?: string | undefined
}) => {
  // In the future, we'll pass in a program id to this hook, when we support multiple programs
  const groupQuery = useQuery<Program>(
    ['group', userId, groupId],
    async () => {
      let programResult
      if (groupId) {
        programResult = await fetchGroupById(groupId)
      } else {
        programResult = await fetchGroupByUserId({ userId })
      }

      if (!programResult) throw new Error('No group found')

      return programResult
    },
    {
      enabled: !!userId || !!groupId,
    },
  )

  const hasSetupGroup = !!groupQuery?.data?.title

  const postGroupId = groupQuery?.data?.id

  const updateGroup = useMutation(
    (data: Program) =>
      postGroup({
        groupId: postGroupId,
        updatedOrCreatedData: data,
      }),
    {
      onSuccess: () => {
        groupQuery?.refetch()
      },
      onError: (err) => {
        const formattedError = formatError(err)
        Toast.error('We had trouble updating the group', formattedError)
        Log.error('useMutation onError', err)
      },
    },
  )

  return {
    ...groupQuery,
    updateGroup,
    meta: { hasSetupGroup },
  }
}
